const fb = require("../firebase.js");

export default {
  namespaced: true,
  actions: {
    async signIn({commit}, params) {
      fb.firebase.auth().signInWithEmailAndPassword(params.email, params.password)
      .then((userCredential) => {
      })
      .catch((error) => {
         commit("snackbar/setSnackbar", {
            color: "error",
            timeout: 4000,
            text: `Incorrect password`
          }, { root: true });
      });
    },

    async signUp({dispatch, commit}, params) {
    {
      fb.firebase.auth().createUserWithEmailAndPassword(params.email, params.password)
        .then((userCredential) => {
           fb.db
          .collection("users")
          .doc(userCredential.user.uid)
          .set({createdAt: fb.firebase.firestore.Timestamp.now(), email: params.email})
          .catch((error) => {
            console.log(error)
          });
        })
        .catch((error) => {
          console.log(error)
          if (error.message === "The email address is already in use by another account.") {
            dispatch('signIn', {email:params.email, password:params.password})
          } else {
            commit("snackbar/setSnackbar", {
            color: "error",
            timeout: 4000,
            text: `Incorrect password`
          }, { root: true });
          }
        });
      }
    },

    async sendPasswordResetEmail({commit}, email) {
      await sendPasswordResetEmail(auth, email)
			.then(() => {
        commit("snackbar/setSnackbar", {
            color: "success",
            timeout: 4000,
            text: "Password reset email sent"
          }, { root: true })
			})
			.catch((error) => {
				if (error.message === "Firebase: Error (auth/user-not-found).") {
          commit("snackbar/setSnackbar", {
            color: "error",
            timeout: 4000,
            text: "No account at this email address"
          }, { root: true })
				}
			});
    },

    async signOut({ commit }) {
      await fb.firebase.auth().signOut()
      commit("self/setSelf", {}, { root: true });
      commit("snackbar/setSnackbar", {
        color: "primary",
        timeout: 3000,
        text: "You are now signed out"
      }, { root: true })
    },
  }
}
  